import { Button } from "@/design-system/components/ui";
import { useAuth } from "@/hooks/useAuth";
import { ChangePasswordCard } from "./AccountPage";

/**
 * Full-screen gate rendered by RequireAuth while `me.mustChangePassword`
 * is set (the password was assigned by an admin — invite initial password
 * or admin reset). The whole app stays blocked until the user picks their
 * own password; the change-password endpoint clears the flag and the
 * follow-up `refresh()` lifts the gate.
 */
export function ForcePasswordChangePage() {
  const { user, logout, refresh } = useAuth();

  return (
    <div className="min-h-screen bg-white-warm flex items-center justify-center p-space-5">
      <div className="w-[640px] max-w-full">
        <h1 className="font-display font-extrabold text-h2 uppercase tracking-wider text-onyx m-0">
          Set a new password
        </h1>
        <p className="text-body text-gray-mid mt-space-2 mb-space-4">
          {user ? `Welcome, ${user.displayName}. ` : ""}
          Your current password was set by an administrator. Choose your own
          to continue — enter the password you signed in with as the current
          password.
        </p>

        <ChangePasswordCard onChanged={() => void refresh()} />

        <div className="mt-space-4 text-center">
          <Button variant="text" size="sm" onClick={() => void logout()}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
